import React from 'react';
import { BrandKitPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';

import { notificationApi } from '../../adapters/get-notification';

export const BrandKitPage = props => <BrandKitPageComponent {...props} notificationApi={notificationApi} />;
